exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".account-details-form-card>.row>.col-lg-12{max-width:1100px}.account-details-form-card .mat-mdc-form-field.full-width{display:block;width:100%;max-width:none}.account-details-form-card .pa-btn{display:inline-block;margin-top:6px;width:160px}.account-details-form-card small{display:block;max-width:720px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Client/app/views/account.management/account.details.component.css
// module id = 1116
// module chunks = 0